import { render, staticRenderFns } from "./ResumenFolios.vue?vue&type=template&id=0905fb1d&scoped=true"
import script from "./ResumenFolios.vue?vue&type=script&lang=js"
export * from "./ResumenFolios.vue?vue&type=script&lang=js"
import style0 from "./ResumenFolios.vue?vue&type=style&index=0&id=0905fb1d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0905fb1d",
  null
  
)

export default component.exports